<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>

    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Products Help</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex>

            <v-container  fluid grid-list-xl >
              <v-layout  justify-start row wrap>
                <v-flex>
                  <h2  class="subheading font-weight-medium">
                      This is where all things related to the products sold is located. From adding new products, editing existing products to searching and filtering products.
                  </h2>
                </v-flex>
              </v-layout>
            </v-container>

            <!---  CREATING A PRODUCT  ---->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Creating a Product</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              On the  Manage Products page, click on the ‘+’ sign located on the bottom right of the screen.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/creation/ClickOn+toAddProduct.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Upon arriving at the page, you will notice multiple fields to fill in.
                            </h3>
                             <ul>
                                <li><h4 class="body-2 font-weight-regular"><b>Product Images</b> - Add pictures by clicking on the  ‘+’  button. The pictures should come from your local machine.</h4></li>
                                <li><h4 class="body-2 font-weight-regular"><b>Name</b> - self explanatory</h4></li>
                                <li><h4 class="body-2 font-weight-regular"><b>Keywords</b> - This is for additional keywords related to the product which makes searching easier. (OPTIONAL)</h4></li>
                                <li><h4 class="body-2 font-weight-regular"><b>Category</b> - Choose which categories this product belongs to.</h4></li>
                                <li><h4 class="body-2 font-weight-regular"><b>Second Category</b> - Some products have a second category hence the Second Category (OPTIONAL)</h4></li>
                                <li><h4 class="body-2 font-weight-regular"><b>Status</b> - Active to put the product up for sale and Disable to do the opposite</h4></li>
                                <li><h4 class="body-2 font-weight-regular"><b>Description box</b> - The large empty box is to write the description for the product</h4></li>
                              </ul>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/creation/FilledInFirstPartOfProductCreation.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Proceed down the page to the second portion of the product creation.
                            </h3>
                            <ul>
                              <li><h4 class="body-2 font-weight-regular"><b>Extra Params</b> - Adds variation to the product. (OPTIONAL) Refer to the tutorial below </h4></li>
                              <li><h4 class="body-2 font-weight-regular"><b>Currency</b> - Available in either USD or CNY</h4></li>
                              <li><h4 class="body-2 font-weight-regular"><b>Supplier</b> - Choose which supplier this product is from. (OPTIONAL)</h4></li>
                              <li><h4 class="body-2 font-weight-regular"><b>Weight</b> - in KG</h4></li>
                              <li><h4 class="body-2 font-weight-regular"><b>Markup</b> - Predetermines the Price box. Refer to the <router-link to="/help/markup" exact>Markup manual</router-link> (OPTIONAL)</h4></li>
                              <li><h4 class="body-2 font-weight-regular"><b>Unlimited Stock</b> - If checked means there is an unlimited amount of the product</h4></li>
                              <!-- <li><h4 class="body-2 font-weight-regular"><b>Allow Bulk Purchase</b> - </h4></li> -->
                              <li><h4 class="body-2 font-weight-regular"><b>Variant</b> - Similar to extra params in the sense that it add variety. Refer to the tutorial below </h4></li>
                            </ul>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/creation/FilledInSecondPartOfProductCreation.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              4
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Depending on whether a variant is selected or not, there might be additional fields to fill in. However for this tutorial, No Variant is selected.
                            </h3>
                             <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/creation/selectNoVariant.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              5
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Proceed down the page to the third portion of the product creation.
                            </h3>
                            <ul>
                              <li><h4 class="body-2 font-weight-regular"><b>Stock</b> - Specify how much stock is availabe. Note, if Unlimited Stock has been checked above then this field would not appear</h4></li>
                              <li><h4 class="body-2 font-weight-regular"><b>Location Code</b> - The code for products location. (OPTIONAL)</h4></li>
                              <li><h4 class="body-2 font-weight-regular"><b>Cost Price</b> - How much the product cost</h4></li>
                            </ul>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/creation/FilledInThirdPartOfProductCreation.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              6
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Fill in the price and quantity in the Price Box. Refer to the Price Box tutorial below for explanation.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/creation/filledInPriceBox.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              7
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click SAVE
                            </h3>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!---  ADDING PRODUCT IMAGE  ---->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Adding Product Image</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Navigate to the Product creation page.
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click on the '+' sign.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/productImage/ClickOn+ToAddProductImage.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click SELECT
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/productImage/ClickSelect.jpg" style="max-width:40%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              4
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Select an image from your local machine.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/productImage/SelectImageFromLocalMachine.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              5
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click ADD
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/productImage/ClickADD.jpg" style="max-width:40%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              6
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              To add more simply click the '+' sign and repeat.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/productImage/Click+ToAddMoreProductImage.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              7
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Scroll to the bottom of the page and click Save.
                            </h3>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!---  ADDING DESCRIPTION IMAGE  ---->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Adding Description Image</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap class="mb-4" >
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="mb-2 subheading font-weight-bold">
                              There is also an option to add images into the description box to aid the explanation.
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              On the end of the description box icons, click the Upload icon.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/descriptionImage/ClickUploadIcon.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click choose file
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/descriptionImage/ClickChooseFile.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Select an image from your local machine
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/descriptionImage/SelectImageFromLocalMachineForDesc.jpg" style="max-width:50%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              4
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Give the image a description
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/descriptionImage/GiveDescriptionForImage.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              5
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click Confirm.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/descriptionImage/ClickConfirm.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              6
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Scroll to the bottom of the page and click Save.
                            </h3>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!---  EDIT DESCRIPTION IMAGE  ---->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Edit Description Image</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Navigate to the picture.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/editDescriptionImage/FindDescriptionPicture.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Double click on the picture.
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              There are 3 field opitons to edit:
                            </h3>
                            <ul>
                              <li><h4 class="body-2 font-weight-regular"><b>URL</b> - This is the url of the picture saved on cloud.</h4></li>
                              <li><h4 class="body-2 font-weight-regular"><b>Description</b> - self explanatory</h4></li>
                              <li><h4 class="body-2 font-weight-regular"><b>Width</b> - This is the width of the picture in pixels.</h4></li>
                            </ul>
                             <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/editDescriptionImage/ThreeFields.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              4
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              When done , simply click Confirm or Cancel if you do not wish to save the changes
                            </h3>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!--- EXTRA PARAMS --->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Extra Params</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap class="mb-4" >
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="mb-2 subheading font-weight-bold">
                              Extra Params allows you to add extra features to the product for the customers to choose. However, having the extra features does incur additional cost. One common use case would be to add different colours and or sizes.
                            </h3>
                            <h3 class="subheading font-weight-bold">
                              Below demonstrates how to add Extra Params and how it affects the selling price.
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click "+" sign on the Extra Params field
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/extraParams/ClickOn+ExtraParams.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Fill in the details (Name & Short description) of the extra parameter.
                              <h4 class="body-2 font-weight-regular">In this demo, extra param of 'Size' is defined. So the customers can choose different sizes of the product.</h4>
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/extraParams/FilledInName&DescriptionforExtraParams.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Set the Type as Select. The ‘Select’ type allows the customers to make different selections.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/extraParams/SelectTypeOfSelect.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              4
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Once completed, additional empty fields will appear below.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/extraParams/AdditionFieldBelowWhenDone.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              5
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click on the "Only single selection" field at the top of the additional field.
                              <h4 class="body-2 font-weight-regular">" Only single selection " means the customer can only select one of the options you specified whereas " Allow multiple selection " means the customers can choose multiple options.</h4>
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/extraParams/SingleOrMultipleSelectino.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              6
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Proceed to fill in the rest of the information such as the Image, Name, Price and Weight.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/extraParams/FillInAdditionalFieldBelow.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              7
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Add additional selection by clicking on the ‘+’ sign located at the bottom right.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/extraParams/AddAdditionalExtraParamSelection.jpg" style="max-width:70%;" />
                              <img src="/static/img/help/products/extraParams/FillInAdditionalExtraParamSelection.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                         <v-layout class="mb-5" row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              8
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              OPTIONAL: The '+' sign on the bottom left is if you want to add another extra params
                            </h3>
                             <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/extraParams/BottomLeft+.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Below shows how these extra params would look when the products are up for sale.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/extraParams/ExtraParamsOnSale.jpg" style="max-width:90%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!--- VARIANTS --->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Variants</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout class="mb-2">
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="mb-4 subheading font-weight-bold">
                              Variants is similar to Extra Params except it is not an additional cost but rather it changes the selling price. Below demonstrates how to add Variants and how it affects the selling price
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click on the Variants field and select the number of variants.
                            </h3>
                            <h4 class="body-2 font-weight-regular">Note: The maximum number of variants you can have is 2. In this case we have chosen just 1.</h4>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/variants/VariantField.jpg" style="max-width:80%;" />
                              <img src="/static/img/help/products/variants/SelectVariant.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Type in the name for the variant. The variant chosen is Color for this demo.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/variants/TypeInNameOfVariant.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Fill in the Variant Option ID and Option Name.
                            </h3>
                            <h4 class="body-2 font-weight-regular">Since this variant is Color, the Option ID and Option Name would be a type of color. Red is chosen as the first option.</h4>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/variants/FillInVariantOptionID&Name.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              4
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Once the Option ID and Option Name has been filled in, additional fields will drop down below.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/variants/AdditionalFieldAfterVariantOption.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              5
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Proceed to fill in the Image, Location Code and Stock Quantity.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/variants/FillInVariantAdditionalField.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              6
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Leave the Cost Price at 0 as it has to do with markups. Refer to the <router-link to="/help/markup" exact>Markup manual</router-link> to learn more.
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              7
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Finally finish defining the price and quantity in the Price Box. Refer to the manual below for more information on the Price Box.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/variants/FillInPriceBox.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              8
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              To add more options, click on the '+' sign and repeat the steps from before.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/variants/AddExtraVariant.jpg" style="max-width:80%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              This is how the variants would look when the product is up for sale
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/variants/VariantsOnSale.jpg" style="max-width:90%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!--- PRICE BOX --->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Price Box</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="mb-2 subheading ">
                              Upon viewing the Price box, you will notice the Qty and Price column. When creating a product you can define how much you want to sell the product at a specific quantity.
                            </h3>
                            <h3 class="subheading ">
                              Looking at the example below, the product is sold at $12.99 for the quantity of 1 and 11.99 for the quantity of 5. This means that from quantity 1 - 4 the product is sold at $12.99 and for any quantity above that would be sold at $11.99.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/priceBox/PriceBox.jpg" style="max-width:40%;" />
                            </div>
                          </v-flex>
                        </v-layout>

                        <v-layout>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 style="text-decoration: underline;" class="subheading font-weight-bold">Wholesale</h3>
                            <h3 class="mb-2 subheading ">
                              You may have also noticed that there is a wholesale column. The Price column is for regular customers whilst wholesale prices are for people that signed up for the wholesale membership. Inorder to specify the price for wholesale buyers, simply check the circle next to the price.
                            </h3>
                            <h3 class="subheading ">
                              Note that the quantity does not apply to wholesale members. For example, if $11.99 was chosen as the wholesale price then wholesale members would buy the product at that price regardless of the quantity specified next to the price.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/priceBox/SelectedWholesalePrice.jpg" style="max-width:40%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!--- FILTERING --->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Filtering</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              The filter system allows you to quick search a product you like to view. You can choose to just filter one property or a combination of multiple properties.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/filtering/FilterFields.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              When you are done with filling in the filter, click on the magnifying glass icon on the right
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/filtering/ClickMagnifyingGlass.jpg" style="max-width:90%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!--- SELECT ACTION --->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Selection Action</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout class="mb-4">
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              In order to provide convenience , this app allows you to select multiple products and set the markup, supplier or categories at once without having to enter the product’s page.
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              In the Manage Products section, select all the items you want to perform the action on by clicking on the small box located at the top left of each item.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/selectionAction/SelectAllItems.jpg" style="max-width:60%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Then click on ‘select action’ at the bottom.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/selectionAction/ClickSelectAction.jpg" style="max-width:60%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              A list of actions will appear for you to choose which you want to perform.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/selectionAction/ListOfActions.jpg" style="max-width:40%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              4
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Select an action and click GO.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/selectionAction/ClickGo.jpg" style="max-width:60%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              5
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Regardless of the actions you have selected, a window pop up would appear with a list for you to choose from. In this case ,it’s the categories. Click on the down arrow and you will see the list
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/selectionAction/SelectACategory.jpg" style="max-width:35%;" />
                              <img src="/static/img/help/products/selectionAction/CategoryList.jpg" style="max-width:70%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              6
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              When a selection has been made, simply click SET.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/selectionAction/ClickSet.jpg" style="max-width:40%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              7
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              A pop up message above would indicate that the setting was successful. Click OK to confirm.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/products/selectionAction/ClickOk.jpg" style="max-width:50%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </div>
</template>

<script>

import SideDrawer from '@/components/SideDrawer.vue'

export default {
  data () {
    return {
      drawer: false
    }
  },
  components: {
    SideDrawer
  },
  mounted () {
    this.openDrawerForDesktop()
  }
}
</script>

<style scoped>

.round-number {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #ff0000;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding-top: 3px;
}

</style>
